import type { ReactNode } from 'react';

type ContainerProps = {
  children: ReactNode;
  /** 'article' = 720px reading column, 'article-wide' = 860px, 'article-full' = 960px, 'content' = 1280px, 'hero' = 1440px */
  size?: 'article' | 'article-wide' | 'article-full' | 'content' | 'hero' | 'dashboard' | 'full';
  className?: string;
  as?: 'div' | 'section' | 'article' | 'main' | 'header' | 'footer' | 'nav';
};

/**
 * Responsive content container.
 * Centers content and applies appropriate max-width at each breakpoint.
 * Uses responsive horizontal padding: tighter on mobile, generous on desktop.
 */
export function Container({
  children,
  size = 'content',
  className = '',
  as: Tag = 'div',
}: ContainerProps) {
  const sizeClasses: Record<string, string> = {
    article:      'max-w-article',
    'article-wide': 'max-w-article-wide',
    'article-full': 'max-w-article-full',
    content:      'max-w-content',
    hero:         'max-w-hero',
    dashboard:    'max-w-dashboard',
    full:         'max-w-none',
  };

  return (
    <Tag
      className={`
        mx-auto w-full
        px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12
        ${sizeClasses[size]}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
    >
      {children}
    </Tag>
  );
}
